import SystemHealthTileView from './SystemHealthTileView'

export default SystemHealthTileView
